import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';

class TopicNews extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    /**
     * 渲染组件
     */
    render() {
        const { content } = this.props;

        return (
            <ul>
                {content.map((item, index) => (
                    <li key={index} className={styles.list}>
                        {item.children && item.children.length > 0 ? (
                            <React.Fragment>
                                <a
                                    className={index === 0 ? styles.bold : ''}
                                    href={item.url}
                                    target="_blank"
                                    title={item.title}>
                                    {item.title}
                                </a>
                                {item.children.map((child, ind) => (
                                    <React.Fragment key={ind}>
                                        <a
                                            className={index === 0 ? styles.bold : ''}
                                            href={child.url}
                                            target="_blank"
                                            title={child.title}>
                                            {child.title}
                                        </a>
                                    </React.Fragment>
                                ))}
                            </React.Fragment>
                        ) : (
                            <a
                                className={index === 0 ? styles.bold : ''}
                                href={item.url}
                                target="_blank"
                                title={item.title}>
                                {item.title}
                            </a>
                        )}
                    </li>
                ))}
            </ul>
        );
    }
}

export default errorBoundary(TopicNews);
